import i18n from '@/plugins/i18n';
import * as metricsData from '@/utils/templates/mqTemplate/amq.cards.config';
import * as navTabs from '@/utils/templates/mqTemplate/mq.constants';
import { kafkaOverviewMetricsData } from '@/utils/templates/mqTemplate/kafka.cards.config';
import activeMqQueueGraphsConfig from '@/utils/templates/mqTemplate/amq.queue.graphs.config';
import activeMqTopicGraphsConfig from '@/utils/templates/mqTemplate/amq.topic.graphs.config';

const messageQueueList = [
  { key: 'AR', label: 'ActiveMQ' },
  { key: 'KA', label: 'Kafka' },
];
const messageQueueTypes = Object.freeze({
  amq: 'AR',
  kafka: 'KA',
});

const metricsDataMapper = Object.freeze({
  [navTabs.NAVTAB_AMQ_KEY.OVERVIEW]: metricsData.amqOverviewMetricsData,
  [navTabs.NAVTAB_KAFKA_KEY.OVERVIEW]: kafkaOverviewMetricsData,
});

const participantListHeader = () =>
  Object.freeze({
    [navTabs.NAVTAB_AMQ_KEY.QUEUES]: i18n.global.t('mq.queueName'),
    [navTabs.NAVTAB_AMQ_KEY.TOPICS]: i18n.global.t('mq.topicName'),
  });

const participantListSearchMsg = () =>
  Object.freeze({
    [navTabs.NAVTAB_AMQ_KEY.QUEUES]: i18n.global.t('mq.searchQueue'),
    [navTabs.NAVTAB_AMQ_KEY.TOPICS]: i18n.global.t('mq.searchTopic'),
  });

const graphsCategories = () =>
  Object.freeze({
    [navTabs.NAVTAB_AMQ_KEY.OVERVIEW]: [
      {
        key: 'overview-memory',
        label: i18n.global.t('mq.memory'),
      },
      {
        key: 'overview-queues',
        label: '',
      },
    ],
    [navTabs.NAVTAB_AMQ_KEY.QUEUES]: [
      {
        key: 'queues-messages',
        label: i18n.global.t('mq.messages'),
      },
    ],
    [navTabs.NAVTAB_AMQ_KEY.TOPICS]: [],
  });

const allParticipantKey = 'all';
const allParticipant = {
  key: allParticipantKey,
  label: i18n.global.t('mq.all'),
};

const participantSelectMsg = Object.freeze({
  [navTabs.NAVTAB_AMQ_KEY.QUEUES]: 'queue',
  [navTabs.NAVTAB_AMQ_KEY.TOPICS]: 'topic',
});

const multiChartMetricList = () => ({
  [messageQueueList[0].key]: {
    [navTabs.NAVTAB_AMQ_KEY.QUEUES]: activeMqQueueGraphsConfig,
    [navTabs.NAVTAB_AMQ_KEY.TOPICS]: activeMqTopicGraphsConfig,
  },
});

const metricLegendLabelMapping = {
  artemis_queue_message_added: i18n.global.t('mq.added'),
  artemis_queue_message_acknowledged: i18n.global.t('mq.acknowledged'),
  artemis_queue_message_killed: i18n.global.t('mq.killed'),
  artemis_queue_message_expired: i18n.global.t('mq.expired'),
  artemis_topic_messages_added: i18n.global.t('mq.added'),
  artemis_topic_messages_acknowledged: i18n.global.t('mq.acknowledged'),
  kafka_broker_jvm_memory_heap: i18n.global.t('mq.heap'),
  kafka_broker_jvm_memory_non_heap: i18n.global.t('mq.nonHeap'),
  kafka_jvm_young_gc_time: i18n.global.t('mq.youngGCTime'),
  kafka_jvm_old_gc_time: i18n.global.t('mq.oldGCTime'),
  kafka_jvm_young_gc_count: i18n.global.t('mq.youngGCCount'),
  kafka_jvm_old_gc_count: i18n.global.t('mq.oldGCCount'),
};

const emptyKeyLabelObj = { key: '', label: '' };
const emptyKeyLabelListWithPermissions = {
  ...emptyKeyLabelObj,
  permissions: [],
};

const castingInfoList = {
  ANYCAST: i18n.global.t('mq.anyCast'),
  MULTICAST: i18n.global.t('mq.multiCast'),
};

const endpoint = 'Endpoint';
const service = 'Service';
const aws_kafka_type = 'aws-msk';
const consumer_group = 'consumer_group';

export {
  messageQueueList,
  messageQueueTypes,
  metricsDataMapper,
  participantListHeader,
  participantListSearchMsg,
  graphsCategories,
  allParticipant,
  allParticipantKey,
  participantSelectMsg,
  multiChartMetricList,
  metricLegendLabelMapping,
  emptyKeyLabelObj,
  castingInfoList,
  endpoint,
  service,
  aws_kafka_type,
  consumer_group,
  emptyKeyLabelListWithPermissions,
};
